import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const proceedingMembershipApi = generateNomenApi(`/proceeding/proceeding-membership`);

export const proceedingMembershipOptions = generateNomenOptions('proceeding-membership', proceedingMembershipApi);
